export const API_ROUTES = {
  completions: "/completions",
  errorNotifications: "/error-notifications",
  messages: "/messages",
  supportAgents: "/support-agents",
  supportTickets: "/support-tickets",
  supplierPhoneCalls: "/supplier/phone-calls",
  centralEmailThreads: "/supplier/central-email-threads",
};
